import React from "react";
import { useDispatch } from "react-redux";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { COLORS } from "@gc-npm/utils.enums.colors";
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_ALIGN,
} from "@gc-npm/components.text";
import CustomLink from "@gc-npm/components.custom-link";
import Button, { BUTTON_WIDTH } from "@gc-npm/components.button";
import Price, {
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
} from "@gc-npm/components.price";
import Spin from "@gc-npm/components.spin";
import IconGlyph from "@gc-npm/components.icon-glyph";
import ICON_ID from "@gc-npm/utils.enums.icon-id";
import ShoppingCartModal from "@/components/Modals/shoppingCartModal";
const ShoppingCartFooterConfigMobile = (props) => {
  const {
    prices,
    selected,
    isConexion,
    title,
    screenType,
    titleOnlyTv,
    resumenText,
    buttonTextDesktop,
    buttonTextMobile,
    buttonTextMobileConfirmation,
    legalText,
    legalTextNoClte,
    taggingInfo,
    stateProps,
  } = props;
  const dispatch = useDispatch();
  const { price, promoPrice } = prices || {};
  const { modulos, permanence, isLoading } = stateProps;

  const onClickOpen = () => {
    dispatch(
      modalActions.addModal({
        id: "ShoppingCartModal",
        Element2Show: ShoppingCartModal,
        modalProps: {
          closeByClickingOutside: true,
          contentPosition: "center--bottom",
          inSceneEffect: "fadeInBottom",
          outSceneEffect: "fadeOutBottom",
          opacityLayoutColor: "blur",
          scrollAllowed: false,
          taggingInfoWhenClickingOutside: {
            ...taggingInfo,
            componentName: "ShoppingCartModal",
            componentContent: "cerrar",
          },
          onCloseHandler: () => {},
        },
        elementProps: {
          prices,
          modulos,
          title,
          titleOnlyTv,
          resumenText,
          screenType,
          buttonTextDesktop,
          buttonTextMobile,
          buttonTextMobileConfirmation,
          legalText,
          legalTextNoClte,
        },
      })
    );
  };

  return (
    <>
      <div className="ShoppingCartFooterConfigMobile shoppingCartBoxShadow">
        <CustomLink
          taggingInfo={{ ...taggingInfo, componentContent: "Desplegar" }}
          onClick={onClickOpen}
          disabled={isLoading}
          className="buttonDesplegar"
        >
          <span className="accessibleAction">Ver resumen de tu selección: </span>
          <div className="info">
            <div className="icon">
              <IconGlyph
                id={ICON_ID.CheuronUp}
                height={20}
                width={20}
                color={TEXT_COLOR.MOVISTAR_BLUE}
              />
            </div>

            <div className="priceSection">
              <div className="prices">
                {isLoading && (
                  <div className="spinnnerWrapper">
                    <div className="Spin loading">
                      <Spin operation="loading" />
                    </div>
                  </div>
                )}
                {!isLoading && (promoPrice || price) >= 0 && (
                  <div className="footerPrice">
                    <Price
                      price={promoPrice || price}
                      color={TEXT_COLOR.MOVISTAR_BLACK}
                      currency="€"
                      quote="mes"
                      size={PRICE_SIZE.XS}
                      fontType={PRICE_FONT_WEIGHT.BOLD}
                      fontTypeUnity={PRICE_FONT_WEIGHT.REGULAR}
                    />
                    <TextInfo
                      text={permanence}
                      kind={TEXT_KIND.SPAN}
                      color={TEXT_COLOR.GREY5}
                      size={TEXT_SIZE.CAPTION2}
                      fontType={TEXT_FONT_WEIGHT.REGULAR}
                      align={TEXT_ALIGN.RIGHT}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </CustomLink>
        {!(selected && isConexion) && (
          <div className="buttons">
            <Button
              label={buttonTextMobile}
              onClick={onClickOpen}
              taggingInfo={{
                ...taggingInfo,
                componentName: taggingInfo.componentName,
              }}
              width={BUTTON_WIDTH.FULL}
              disabled={isLoading}
            />
          </div>
        )}
      </div>
      <style jsx>
        {`
          .accessibleAction {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip-path: inset(50%);
            white-space: nowrap;
          }
          .ShoppingCartFooterConfigMobile {
            position: fixed;
            z-index: 30;
            bottom: 0px;
            left: 0px;
            width: 100%;
            background-color: ${COLORS.grey100};
            border-top: 2px solid ${COLORS.grey200};
            padding: 0.75rem 0.25rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            min-height: 74px;
            gap: 8px;
            
            &.shoppingCartBoxShadow {
              box-shadow: 0px -2px 8px #00000029;
            }
            .info {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              gap: 0.5rem;
            }
            .buttons {
              display: flex;
              justify-content: space-between;
              flex-wrap: nowrap;
              flex-direction: row;
              gap: 0.5rem;
              width: inherit;
              max-width: 50%;
              align-items: center
            }
            .prices {
              display: flex;
              flex-direction: row;
              gap: 1rem;
              .footerPrice {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
              }
              .spinnnerWrapper {
                padding-right: 1rem;
                width: 100%;
                display: flex;
                position: relative;
                flex-direction: row;
                justify-content: center;
                align-items: center;
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default ShoppingCartFooterConfigMobile;
